export default __webpack_public_path__ + "static/cactus1-d731c69487bdb85dae872cb9ebedaa4d.png";